import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { cn } from '../lib/cn.js';
/**
 * Прокручиваемый `role="listbox"` выпадающего списка (`TagInput`, `Combobox`).
 *
 * Зачем отдельный кусок, а не голый `<ul className="overflow-y-auto">`:
 *
 * 1. Список живёт в портале `Popover` — в DOM он ВНЕ диалога. Открытый Radix
 *    `Dialog` держит `react-remove-scroll`, а тот гасит колесо и тач-прокрутку
 *    всего, что вне его DOM-поддерева, — список с 250 странами в «Списках
 *    стран» не прокручивался вовсе. Свой `RemoveScroll` на время открытого
 *    списка становится верхним замком: прокрутка внутри списка разрешена,
 *    вокруг — заблокирована (как у Radix `Select`). Полосу прокрутки страницы
 *    он не трогает (`removeScrollBar={false}`) — иначе раскладка дёргалась бы
 *    при каждом открытии списка вне диалога.
 * 2. Стрелки клавиатуры двигают подсветку — подсвеченный пункт обязан быть
 *    виден, поэтому список докручивается к нему (`block: 'nearest'`).
 */
export function OptionListbox({ id, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-multiselectable': multiselectable, activeOptionId, className, children, }) {
    const listRef = React.useRef(null);
    React.useEffect(() => {
        if (!activeOptionId)
            return;
        const list = listRef.current;
        if (!list)
            return;
        const el = list.ownerDocument.getElementById(activeOptionId);
        // jsdom и старые движки без scrollIntoView — молча без прокрутки.
        if (el && list.contains(el) && typeof el.scrollIntoView === 'function') {
            el.scrollIntoView({ block: 'nearest' });
        }
    }, [activeOptionId]);
    return (_jsx(RemoveScroll, { removeScrollBar: false, allowPinchZoom: true, children: _jsx("ul", { ref: listRef, id: id, role: "listbox", ...(ariaLabelledBy ? { 'aria-labelledby': ariaLabelledBy } : { 'aria-label': ariaLabel }), ...(multiselectable ? { 'aria-multiselectable': true } : {}), className: cn('max-h-60 overflow-y-auto overscroll-contain', className), children: children }) }));
}
OptionListbox.displayName = 'OptionListbox';
//# sourceMappingURL=option-listbox.js.map